import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';

import { catchError, throwError } from 'rxjs';

import { ErrorsModalComponent } from '@app/shared/components/modals/errors-modal/errors-modal.component';
import { ErrorStatus } from '@app/shared/components/modals/errors-modal/enums/errors-modal.enums';

export const errorsInterceptor: HttpInterceptorFn = (req, next) => {
  const matDialog = inject(MatDialog);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 422) {
        matDialog.open(ErrorsModalComponent, {
          data: ErrorStatus.ProfileNotFilled
        });
      }
      return throwError(error);
    })
  );
};
